import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";

import {
  API_COUNTRY_CODES_LIST,
  API_NUMBER_STATUS,
  API_OPERATORS_LIST,
  API_STATES_LIST,
  API_TRUNKS_LIST
} from "../../../service/url";
import { getApiCall, postApiCall } from "../../../service/httpCall";
import {
  NUMBERS_TYPES,
  NUMBER_ROUTING_TYPE,
} from "../../../utilities/constant";

export default function RenderNumberForm(props) {



  // console.log("PROPS CATEGORY", props);

  

  const [countryCodesList, setCountryCodesList] = useState([]);
  const [numberStatusList, setNumberStatusList] = useState([]);
  const [stateCodeList, setStateCode] = useState([]);
  const isIndia = props.countryCodeId === 'IN';
  const [operatorsList, setOperatorsList] = useState([]);
  const [trunksList, setTrunksList] = useState([]);
  const currencySymbol = isIndia ? '₹' : '$';

  useEffect(() => {
    getApiCall(API_COUNTRY_CODES_LIST, {})
      .then(onCountryCodesListSuccess)
      .catch(onError);

    getApiCall(API_NUMBER_STATUS, {})
      .then(onNumberStatusSuccess)
      .catch(onError);

    getApiCall(API_OPERATORS_LIST, {})
     .then(onOperatorListSuccess)
     .catch(onError);  

    getApiCall(API_TRUNKS_LIST, {})
      .then(onTrunksListSuccess)
      .catch(onError);
  
  }, []);

  function onOperatorListSuccess(resp) {
    setOperatorsList(resp);
  }

  function onTrunksListSuccess(resp) {
    setTrunksList(resp);
  }

  useEffect(() => {
    if (props.countryCodeId) {
      const params = {
        countryCode: props.countryCodeId,
      };
      postApiCall(API_STATES_LIST, params)
        .then((response) => {
          setStateCode(response);
        })
        .catch((error) => console.error("Error while fetching states:", error));
    }
  }, [props.countryCodeId]);

  function onNumberStatusSuccess(resp) {
    setNumberStatusList(resp);
  }

  function onCountryCodesListSuccess(resp) {
    setCountryCodesList(resp);
  }

  function onError(err) {
    console.log(err);
  }

    useEffect(() => {
      if (props.countryCodeId) {
        const params = {
          countryCode: props.countryCodeId,
        };
        postApiCall(API_STATES_LIST, params)
          .then((response) => {
            setStateCode(response);
          })
          .catch((error) => console.error("Error while fetching states:", error));
        
        // Auto-set currency based on country code
        // India (IN) -> INR, Others -> USD
        if (props.countryCodeId === 'IN') {
          props.setCurrency('INR');
        } else if (props.countryCodeId) {
          props.setCurrency('USD');
        }
      }
    }, [props.countryCodeId]);

  useEffect(() => {
    if (props.category === "Free") {
      props.setCost(0);
    }
  }, [props.category]);


  return (
    <>
      <div className="row g-4">
        <Form.Group className="col-md-4 form-group mb-1">
          <Form.Label htmlFor="numberRouteType">Number Routing: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          <Form.Select
            id="numberRouteType"
            value={props.numberRoutingType}
            className="p-2"
            onChange={(e) => props.setNumberRoutingType(e.target.value)}
            required
          >
            <option value="">Select Number Routing</option>
            {NUMBER_ROUTING_TYPE.map((numberRouting, idx) => (
              <option key={idx} value={numberRouting.value}>
                {numberRouting.label}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
        <Form.Group className="col-md-4 form-group mb-1">
          <Form.Label htmlFor="number_type">Number Type: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          <Form.Select
            id="numberType"
            value={props.numberType}
            className="p-2"
            onChange={(e) =>props.setNumberType(e.target.value)}
            required
          >
             <option value={""}>Select Number Type</option>
            {NUMBERS_TYPES.map(function(val,idx){
              return(
                <option key ={idx} value={val.value}>
                  {val.label}
                </option>
              )
            })}
          </Form.Select>
        </Form.Group>
        <Form.Group className="col-md-4 form-group mb-1">
          <Form.Label htmlFor="currency">Currency: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          <Form.Select
            id="currency"
            value={props.currency}
            className="p-2"
            onChange={(e) => props.setCurrency(e.target.value)}
            disabled={props.countryCodeId ? true : false}
            style={props.countryCodeId ? { cursor: 'not-allowed', backgroundColor: '#e9ecef' } : {}}
            required
          >
            <option value="">Select Currency</option>
            <option value="INR">INR</option>
            <option value="USD">USD</option>
          </Form.Select>
        </Form.Group>

        {props.numberType === 'DID' && (
          <Form.Group className="col-md-3 form-group mb-1">
            <Form.Label htmlFor="category">Category: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
            <Form.Select
              id="category"
              value={props.category}
              className="p-2"
              onChange={(e) =>props.setCategory(e.target.value)}
              required
            >
              <option value="">Select Category</option>
              <option value="Free">Free</option>
              <option value="Paid">Paid</option>
            </Form.Select>
          </Form.Group>
        )}
        {props.numberType === 'DID' && (
          <Form.Group className="col-md-4 form-group mb-1">
          <Form.Label htmlFor="number_type">State Code: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          <Form.Select
            id="stateCode"
            required
            value={props.stateCode}
            className="p-2"
            onChange={(e) => props.setStateCode(e.target.value)}
          >
            <option value={""}>Select State Code</option>
            {stateCodeList && stateCodeList.map(function (val, idx) {
              return (
                <option key={idx} value={val.isoCode}>
                  {val.name}{` (${val.isoCode})`}
                </option>
              );
            })}
          </Form.Select>
        </Form.Group>
        )}
        <Form.Group className="col-md-2 form-group mb-1">
          <Form.Label htmlFor="country_code">Country Code: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          <Form.Select
            id="countryCodeId"
            required
            value={props.countryCodeId}
            className="p-2"
            onChange={(e) => props.setCountryCodeId(e.target.value)}
          >
            <option value={""}>Select Country Code</option>
            {countryCodesList.map(function (val, idx) {
              return (
                <option key={idx} value={val.code}>
                  {val.name}{` (${val.code})`}
                </option>
              );
            })}
          </Form.Select>
        </Form.Group>
        <Form.Group className="col-md-3 form-group mb-1">
          <Form.Label htmlFor="did">DID: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          <Form.Control
            type="text"
            placeholder="DID"
            id="did"
            value={props.DID}
            // onChange={(e) => props.setDID(e.target.value)}
            maxLength={10}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              props.setDID(value);
            }}
            required
          />
        </Form.Group>
          <Form.Group className="col-md-3 form-group mb-1">
            <Form.Label htmlFor="cost">
              Cost: <span style={{ color: "red", margin: "0 4px" }}>*</span>
            </Form.Label>

            <div className="input-group">
              <span className="input-group-text bg-light" style={{ cursor: 'not-allowed' }}>
                {currencySymbol}
              </span>

              <Form.Control
                type="number"
                placeholder="Cost"
                id="cost"
                value={props.cost}
                readOnly={props.category === "Free"}
                onChange={(e) => {
                  if (props.category === "Free") return;

                  const value = Number(e.target.value);
                  props.setCost(value >= 0 ? value : 0);
                }}
                required
              />
            </div>
          </Form.Group>


          <Form.Group className="col-md-3 form-group mb-1">
          <Form.Label htmlFor="number_type">Operator: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
            <Form.Select
              id="operator"
              placeholder="Operator"
              className="p-2"
              required
              value={props.operator.toLowerCase()}
              onChange={(e) => props.setOperator(e.target.value)}
            >
              <option value={""}>Select Operator</option>
              {operatorsList.map(function (val, idx) {
                return (
                  <option key={idx} value={val.name.toLowerCase()}>
                    {val.name}
                  </option>
                );
              })}
            </Form.Select>
          </Form.Group>
        <Form.Group className="col-md-3 form-group mb-1">
          <Form.Label htmlFor="status">Status: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          <Form.Select
            id="numberStatusId"
            required
            value={props.status}
            className="p-2"
            onChange={(e) => props.setStatus(e.target.value)}
          >
            <option value={""}>Select Status</option>
            {numberStatusList.map(function (val, idx) {

              // console.log("VALUE HERE STATUS", val);
              return (
                <option key={idx} value={val.id}>
                  {val.status}
                </option>
              );
            })}
          </Form.Select>
        </Form.Group>
        {props.numberType === 'DID' && (
          <Form.Group className="col-md-3 form-group mb-1">
            <Form.Label htmlFor="status">Select Trunk: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
            <Form.Select
              id="currency"
              value={props.trunks}
              className="p-2"
              onChange={(e) => props.setTrunks(e.target.value)}
              required
            >
              <option value="">Select Trunks</option>
              {trunksList.map(function (val, idx) {
                return (
                  <option key={idx} value={val.id}>
                    {val.name}
                  </option>
                );
              })}
            </Form.Select>
          </Form.Group>
        )}
      </div>
      <hr />
    </>
  );
}
